import { IResult } from '../../ts/ServerApi/types/IResponse';
import { Request } from '../../ts/ServerApi/requests/Request';

export interface ICancelBackgroundJobParams {
  backgroundJobId: string;
  cancellationReason: string;
  notifyJobCreator: boolean;
  notifyProjectOwner: boolean;
  notifySiteAdministrators: boolean;
  notifyServerAdministrators: boolean;
}

export interface ICancelBackgroundJobResult extends IResult {
}

export class CancelBackgroundJobRequest extends Request<ICancelBackgroundJobParams, ICancelBackgroundJobResult> {
  constructor(params: ICancelBackgroundJobParams) {
    super('cancelBackgroundJob', params);
  }
}
